export const padLinear = ([start, end], fraction) => {
  const padding = ((end - start) * fraction) / 2;
  return [start - padding, end + padding];
};
